import { o_util } from "../chunks/common-namespaces-client-CHyZgmlk.mjs";
import { otto } from "../chunks/common-nexus-client-BxVeVD8v.mjs";
import { asExport } from "../chunks/common-core-client-BYCqsbss.mjs";
import { noop } from "../chunks/common-function-client-BVBvJr6Z.mjs";
const apm = /*           */ asExport(otto, "apm", {});
const agent = /*           */ asExport(apm, "agent", noop);
const isActive = /*           */ asExport(apm, "isActive", noop);
const getCurrentTransaction = /*           */ asExport(
  apm,
  "getCurrentTransaction",
  noop
);
const startSpan = /*           */ asExport(apm, "startSpan", noop);
const captureError = /*           */ asExport(
  apm,
  "captureError",
  noop
);
const mark = /*           */ asExport(apm, "mark", noop);
const addLabels = /*           */ asExport(apm, "addLabels", noop);
const sendCustomError = /*           */ asExport(
  apm,
  "sendCustomError",
  noop
);
const apmSync = /*           */ asExport(o_util, "apm", {});
const runWithSpan = /*           */ asExport(apmSync, "runWithSpan", noop);
const withSpan = /*           */ asExport(apmSync, "withSpan", noop);
export {
  addLabels,
  agent,
  apm,
  apmSync,
  captureError,
  getCurrentTransaction,
  isActive,
  mark,
  runWithSpan,
  sendCustomError,
  startSpan,
  withSpan
};
/*                                   */
